<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'muted': !show}"
    :text="$t('Invite user')"
    icon="email"
    icon-class=""
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { trackEvent } from '../../gtm'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'

export default {
  computed: {
    show() {
      return this.bcSelectedStore.listSelected.length > 0
    },
    ...mapStores(useBcSelectedStore)
  },
  methods: {
    async click() {
      this.loading = true
      let inviteIds = this.bcSelectedStore.listSelected.map((user) => user._id).join(',')
      await NetteAjax.ajax({
        url: this.$presenter.inviteUsersLink.replace('IDS', inviteIds),
        onSuccess: () => {
          this.bcSelectedStore.resetSelected()
        }
      })
      trackEvent(this.$route.matched[0].name, 'sendInvite')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
